<!-- Primary -->
<ng-container *ngIf="color === 'primary'" >
  <div class="md-input-search md-input-search__primary">
    <div class="md-input-search__input d-flex justify-content-start align-items-center">
      <span class="md-input-search__span d-flex justify-content-center align-items-center">
        <mat-icon>search</mat-icon>
      </span>
      <input [value]="value" type="text" autocomplete="off">
    </div>
    <ng-template #emptyPatients>
      <div class="emptyPatient-content">
  
      </div>
    </ng-template>
  </div>
</ng-container>

<ng-container *ngIf="color === 'primary-stroked'"> 
</ng-container>

<ng-container *ngIf="color === 'primary-text'">

</ng-container>
<ng-container *ngIf="color === 'primary-opacity'">
  
</ng-container>
<!-- Secondary -->
<ng-container  *ngIf="color === 'accent'">
</ng-container>

<ng-container *ngIf="color === 'accent-stroked'">
  
</ng-container>

<ng-container *ngIf="color === 'accent-text'">
  
</ng-container>
<ng-container *ngIf="color === 'accent-opacity'">
  
</ng-container>
<!-- Warn -->
<ng-container *ngIf="color === 'warn'">
</ng-container>

<ng-container *ngIf="color === 'warn-stroked'">
  
</ng-container>

<ng-container *ngIf="color === 'warn-text'">
  
</ng-container>
<ng-container *ngIf="color === 'warn-opacity'">
  
</ng-container>
<ng-template #buttonContent>
  <ng-content></ng-content>
</ng-template>